export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "en": {
        "tabs": {
          "courses": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Courses"])},
          "webinars": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Webinars"])}
        }
      },
      "ru": {
        "tabs": {
          "courses": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Курсы"])},
          "webinars": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Вебинары"])}
        }
      },
      "es": {
        "tabs": {
          "courses": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cursos"])},
          "webinars": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Webinarios"])}
        }
      },
      "kk": {
        "tabs": {
          "courses": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Курстар"])},
          "webinars": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Вебинарлар"])}
        }
      },
      "uz": {
        "tabs": {
          "courses": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kurslar"])},
          "webinars": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vebinarlar"])}
        }
      },
      "de": {
        "tabs": {
          "courses": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kurse"])},
          "webinars": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Webinare"])}
        }
      },
      "fr": {
        "tabs": {
          "courses": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cours"])},
          "webinars": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Webinaires"])}
        }
      },
      "it": {
        "tabs": {
          "courses": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Corsi"])},
          "webinars": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Webinari"])}
        }
      }
    }
  })
}
